import React from 'react';
import { getLookupInternalAuditHistoryProps } from 'react-scale/corp/components/Lookup/BaseLookupObject';
import InternalAuditHistory from 'react-scale/corp/components/Lookup/sections/InternalAuditHistory';
import HideableSection from 'react-scale/corp/components/UI/HideableSection';
import { ISensorFusionSubstageInstanceLookupDto } from '@scale/sensor-fusion-shared';

type SubstageInstanceInternalAuditProps = {
  substageInstance: ISensorFusionSubstageInstanceLookupDto;
};

const SubstageInstanceInternalAuditPanel = ({
  substageInstance,
}: SubstageInstanceInternalAuditProps) => {
  const internalAuditHistoryProps = getLookupInternalAuditHistoryProps({
    object: substageInstance,
  });

  if (!internalAuditHistoryProps) return null;

  return (
    <HideableSection name="Internal Audit History">
      <InternalAuditHistory {...internalAuditHistoryProps} />
    </HideableSection>
  );
};

export default SubstageInstanceInternalAuditPanel;
